var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, styled } from "@mui/material";
import * as React from "react";
import "./HDSpinner.css";
var HDSpinner = function (props) {
    var offset = ((Date.now() % 1000) / 1000) * 360;
    var StyledBox = styled("div")({
        color: "var(--blue-color-70)",
    });
    return (_jsx(Box, __assign({ style: {
            transformOrigin: "50% 50%",
            transform: "rotate(".concat(offset, "deg)"),
            height: 35,
            width: 35,
        } }, { children: _jsx(StyledBox, __assign({ "data-testid": "heidrick-spinner", className: "spinner" }, { children: _jsx(Box, {}) })) })));
};
export default HDSpinner;
